import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Table from '../../common/table/Table';
import TextBlink from '../../common/table/TextBlink';
import { getDataFollowKeyByDot } from '../../helpers/Common';
import {
  formatChange,
  formatPrice,
  formatTextFloat,
  formatVolume,
} from '../../helpers/Text';
import { withComponentId } from './../../common/ComponentIdContext';
import { getColorRedGreen } from '../../helpers/Color';
import Const from './Const';
import { REDUCER_NAME } from './reducer';
import TimeZoneHandle from '../../common/timezone-handle';

class TableQuoteMovement extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sliceFrom: 0,
      sliceTo: 60,
      itemPerPage: 30,
      page: 2,
      totalPage: null,
    };
    this.tableRef = React.createRef();
  }

  componentWillReceiveProps(nextProps) {
    const { data = [] } = this.props;
    const { data: nextData = [] } = nextProps;

    if (data && nextData.length !== data.length) {
      this.getPaginationInfo(nextProps.data);
    }
  }

  getPaginationInfo = data => {
    const { itemPerPage } = this.state;
    const totalPage = data.length ? Math.ceil(data.length / itemPerPage) : 0;
    if (totalPage) this.setState({ totalPage });
  };

  handleLoadMore = () => {
    const { totalPage, page } = this.state;
    if (page === totalPage) return;
    this.setState({
      page: page + 1,
    });
  };

  handleSliceTo = (page, sliceTo) => {
    const { data } = this.props;
    const { totalPage } = this.state;
    if (!totalPage || page === 1) return page * this.state.itemPerPage;
    if (page < totalPage) return page * sliceTo;
    return data.length;
  };

  handleScroll = e => {
    const { page, totalPage } = this.state;
    const bottom =
      e.target.scrollHeight - Math.round(e.target.scrollTop) ===
      e.target.clientHeight;
    if (page === totalPage) return;
    if (bottom) {
      this.handleLoadMore();
    }
  };

  schema = (listColumn, i18nTitleKey) =>
    Object.keys(Const.listColumn).map((item, index) => {
      const key = listColumn[item];
      const title = `${i18nTitleKey}.${item}`;

      const result = {
        key,
        title,
      };

      if (key === Const.listColumn.time) {
        return {
          disableSort: true,
          ...result,
          thStyle: {
            width: '50px',
            textAlign: 'left',
          },
          render: text => (
            <div className="font-weight-light">
              <TimeZoneHandle time={text} />
            </div>
          ),
        };
      }

      if (_.includes([listColumn.bidVolume], key)) {
        return {
          ...result,
          disableSort: true,
          render: (text, item) => {
            const change = formatChange(
              formatPrice(
                getDataFollowKeyByDot(item, Const.listColumn.changeVolume),
              ),
            );
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                <span className={getColorRedGreen(text, 'text')}>
                  {`(${change}) ${formatTextFloat(formatVolume(text))}`}
                </span>
              </TextBlink>
            );
          },
        };
      }

      if (
        _.includes(
          [
            listColumn.bid,
            listColumn.bid,
            listColumn.priceDone,
            listColumn.ask,
          ],
          key,
        )
      ) {
        return {
          ...result,
          disableSort: true,
          render: (text, item) => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {formatTextFloat(formatPrice(text))}
              </TextBlink>
            );
          },
        };
      }

      if (
        _.includes(
          [
            listColumn.totalVolume,
            listColumn.changeVolume,
            listColumn.volumeDone,
            listColumn.ask,
          ],
          key,
        )
      ) {
        return {
          ...result,
          disableSort: true,
          render: (text, item) => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {formatTextFloat(formatVolume(text))}
              </TextBlink>
            );
          },
        };
      }

      if (_.includes([listColumn.askVolume], key)) {
        return {
          ...result,
          disableSort: true,
          render: (text, item) => {
            const change = formatChange(
              formatPrice(
                getDataFollowKeyByDot(item, Const.listColumn.changeVolume),
              ),
            );
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                <span className={getColorRedGreen(text, 'text')}>
                  {`(${change}) ${formatTextFloat(formatVolume(text))}`}
                </span>
              </TextBlink>
            );
          },
        };
      }

      if (_.includes([listColumn.type], key)) {
        return {
          disableSort: true,
          ...result,
          thStyle: { textAlign: 'left', width: '50px' },
          render: text => {
            if (text === Const.typeList.bu) {
              return (
                <div className="text-s-color-5 text-left font-weight-bold">
                  {text}
                </div>
              );
            }
            if (text === Const.typeList.sd) {
              return (
                <div className="text-s-color-3 text-left font-weight-bold">
                  {text}
                </div>
              );
            }
            return <div className="text-left"> -- </div>;
          },
        };
      }

      return {
        ...result,
        disableSort: true,
        render: text => (
          <TextBlink item={item} tradingDate="tradingDate">
            {text}
          </TextBlink>
        ),
      };
    });

  render() {
    const { data = [], isFetching } = this.props;
    const { page, itemPerPage } = this.state;
    const sliceToIndex = this.handleSliceTo(page, itemPerPage);
    const clone = data.map((item, index) => {
      return {
        ...item,
        id: index + 1,
      };
    });
    const listTransactionTime = clone
      .slice(0, sliceToIndex)
      .map(item => getDataFollowKeyByDot(item, 'id'));
    const listTransactionByTime = _.keyBy(clone, 'id');

    return (
      <Table
        scrollRef={this.tableRef}
        onScrollFunction={this.handleScroll}
        stickyFirstColumn={false}
        thValign="top"
        ids={listTransactionTime}
        isLoading={isFetching}
        resizeable={true}
        columnDraggable={false}
        rowDraggable={false}
        hideColumns={Const.listHideColumn}
        getDataFromRedux={() => {
          return listTransactionByTime;
        }}
        schema={this.schema(Const.listColumn, 'quoteMovement.listTitleTable')}
      />
    );
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    id: componentId,
    i18n: state.i18n,
    isFetching: state[REDUCER_NAME].listMultiComponent[componentId].isFetching,
    data:
      state[REDUCER_NAME].listMultiComponent[componentId].quoteMovementData
        .matches,
    isDerivatives:
      state[REDUCER_NAME].listMultiComponent[componentId].condition
        .isDerivatives,
  };
};

const enhance = compose(
  withComponentId,
  connect(mapStateToProps),
);

export default enhance(TableQuoteMovement);
